<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card flat>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-col cols="6" sm="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
          </v-card-title>
          <v-data-table :headers="headers" :items="contactcenterrecords" :search="search">
            <template v-slot:[`item.createdAt`]="{ item }">
              {{ item.createdAt | formatdate }}
            </template>
             <template v-slot:[`item.chat.phoneNumber`]="{ item }">
                <router-link :to="`/session/${item.id}/messages`">{{item.chat.phoneNumber}}</router-link>
             </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu right bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon color="accent">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <!-- <v-list-item :to="`/chat/messages/${item.chat.id}/${item.id}`" v-if="item.sessionChoice.status === 'CHAT_IN_PROGRESS'">
                    <v-list-item-title>Chat</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="triggerStartChat(item)" v-if="item.sessionChoice.status === 'OPEN'">
                    <v-list-item-title>Start Chat</v-list-item-title>
                  </v-list-item> -->
                  <v-list-item @click="triggerReOpenChat(item)" v-if="item.sessionChoice.status === 'RESOLVED'">
                    <v-list-item-title>Re Open</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="showMoveToCMDialog(item)" v-if="item.sessionChoice.status === 'OPEN'">
                    <v-list-item-title>Move To CM</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="showResolveChatDialog(item)" v-if="item.sessionChoice.status === 'HANDED_OVER' || item.sessionChoice.status === 'OPEN'">
                    <v-list-item-title>Mark as Resolved</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="resolvedDialog" max-width="60%">
      <v-card>
        <v-card-title class="headline">Resolve Chat</v-card-title>
        <v-card-text>
          <h4 class="mt-2">Are you sure you want to resolve chat?</h4>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="resolvedDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerResolveChat">Resolve</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="moveToCMDialog" max-width="60%">
      <v-card>
        <v-card-title class="headline">Move Chat</v-card-title>
        <v-card-text>
          <h4 class="mt-2">Are you sure you want to move chat to CM Chat app?</h4>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="moveToCMDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerMoveChatToCM">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ContactCenterRecords',
  data: () => ({
    search: '',
    headers: [
      { text: 'Ref No', value: 'sessionChoice.refNo' },
      { text: 'Date Created', value: 'createdAt' },
      { text: 'Phone Number', value: 'chat.phoneNumber' },
      { text: 'Message', value: 'sessionChoice.chatMessage' },
      { text: 'Status', value: 'sessionChoice.status' },
      { text: 'Owner', value: 'chat.user.name' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    resolvedDialog: false,
    session: {},
    moveToCMDialog: false
  }),
  computed: mapState({
    contactcenterrecords: state => state.botsession.contactcenterrecords
  }),
  methods: {
    ...mapActions({ resolveChat: 'chat/resolveChat', startChat: 'chat/startChat', reOpenChat: 'chat/reOpenChat', moveChatToCM: 'chat/moveChatToCM' }),
    showResolveChatDialog (item) {
      this.session = item
      this.resolvedDialog = true
    },
    showMoveToCMDialog (item) {
      this.session = item
      this.moveToCMDialog = true
    },
    triggerResolveChat () {
      this.resolveChat(this.session).then(response => {
        if (!response.data.isError) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'success', message: response.data.message }, { root: true })
          this.$store.dispatch('botsession/getContactCustomerCareRecords')
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message }, { root: true })
        }
        this.resolvedDialog = false
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    },
    triggerStartChat (item) {
      this.startChat(item).then(response => {
        if (!response.data.isError) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'success', message: response.data.message }, { root: true })
          this.$store.dispatch('botsession/getContactCustomerCareRecords')
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message }, { root: true })
        }
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    },
    triggerReOpenChat (item) {
      this.reOpenChat(item).then(response => {
        if (!response.data.isError) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'success', message: response.data.message }, { root: true })
          this.$store.dispatch('botsession/getContactCustomerCareRecords')
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message }, { root: true })
        }
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    },
    triggerMoveChatToCM () {
      this.moveChatToCM(this.session).then(response => {
        if (!response.data.isError) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'success', message: response.data.message }, { root: true })
          this.$store.dispatch('botsession/getContactCustomerCareRecords')
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message }, { root: true })
        }
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    }
  },
  created () {
    this.$store.dispatch('botsession/getContactCustomerCareRecords')
  }
}
</script>
